import React from "react";
import { Col, Row, Skeleton } from "antd";
import { useTranslation } from "react-i18next";

import {
  ApiPaths,
  type TargetSystem,
} from "@/providers/smarta-documents/documents-api-client";
import { api } from "../client";
import { Value } from "../../components/styles";

type LocaleKey = keyof TargetSystem["locales"];

export const AccountingSystem = ({
  targetSystem,
}: {
  targetSystem: string;
}) => {
  const { i18n } = useTranslation();
  const { data: targetSystemData, isLoading } = api.useQuery(
    "get",
    ApiPaths.getApiTarget_systemsByTargetSystemId,
    {
      params: { path: { targetSystemId: targetSystem } },
    }
  );

  const locale = (i18n.language?.substring(0, 2) as LocaleKey) || "de";
  const systemInfo = targetSystemData?.data;

  return isLoading ? (
    <Row align="middle" gutter={16} wrap={false}>
      <Col>
        <Skeleton.Avatar active size={32} shape="square" />
      </Col>
      <Col flex="auto" style={{ minWidth: 0 }}>
        <Skeleton.Input active size="small" style={{ width: 120 }} />
      </Col>
    </Row>
  ) : systemInfo ? (
    <Row align="middle" gutter={16} wrap={false}>
      <Col>
        <img
          src={systemInfo.logoUrl}
          alt={systemInfo.locales[locale]?.name}
          style={{ width: 32, height: 32, objectFit: "contain" }}
        />
      </Col>
      <Col flex="auto" style={{ minWidth: 0 }}>
        <Value emphasized>{systemInfo.locales[locale]?.name}</Value>
      </Col>
    </Row>
  ) : (
    <span>{targetSystem}</span>
  );
};
